(function(){
  'use strict';
  var header=document.getElementById('SiteHeader');
  if(header){window.addEventListener('scroll',function(){header.classList.toggle('scrolled',window.scrollY>8)},{passive:true})}
  var burger=document.getElementById('BurgerBtn'),drawer=document.getElementById('NavDrawer'),overlay=document.getElementById('NavOverlay'),closeBtn=document.getElementById('NavClose');
  function openNav(){if(drawer)drawer.classList.add('open');if(overlay)overlay.classList.add('open');document.body.style.overflow='hidden'}
  function closeNav(){if(drawer)drawer.classList.remove('open');if(overlay)overlay.classList.remove('open');document.body.style.overflow=''}
  if(burger)burger.addEventListener('click',openNav);
  if(closeBtn)closeBtn.addEventListener('click',closeNav);
  if(overlay)overlay.addEventListener('click',closeNav);
  var mainImg=document.getElementById('mainProductImg');
  document.querySelectorAll('.product-gallery__thumb').forEach(function(t){
    t.addEventListener('click',function(){
      if(mainImg)mainImg.src=t.dataset.full||t.src;
      document.querySelectorAll('.product-gallery__thumb').forEach(function(x){x.classList.remove('is-active')});
      t.classList.add('is-active');
    });
  });
  document.querySelectorAll('.option-values').forEach(function(g){
    g.querySelectorAll('.option-value').forEach(function(b){
      b.addEventListener('click',function(){
        g.querySelectorAll('.option-value').forEach(function(x){x.classList.remove('is-selected')});
        b.classList.add('is-selected');
      });
    });
  });
  var fill=document.querySelector('.stock-bar__fill');
  if(fill){var pct=fill.dataset.pct||'22';setTimeout(function(){fill.style.width=pct+'%'},300)}
  document.querySelectorAll('.filter-btn').forEach(function(b){
    b.addEventListener('click',function(){
      document.querySelectorAll('.filter-btn').forEach(function(x){x.classList.remove('is-active')});
      b.classList.add('is-active');
    });
  });
  if('IntersectionObserver' in window){
    var obs=new IntersectionObserver(function(entries){entries.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-visible');obs.unobserve(e.target)}})},{threshold:0.1});
    document.querySelectorAll('.reveal').forEach(function(el){obs.observe(el)});
  } else {
    document.querySelectorAll('.reveal').forEach(function(el){el.classList.add('is-visible')});
  }
})();
